import styled from '@emotion/styled';

export const AuthContainer = styled.div`
  background: transparent linear-gradient(180deg, #3927514d 0%, #80808000 100%) 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  height: 100vh;
  // width: 100vw;
   font-family: PoppinsMedium;
   
   
`;
export const FormContainer = styled.div`
  max-width: 400px;
  width: 100%;
  border: 1px solid #f6f6f6;
  border-radius: 10px;
  box-shadow: 0 0 50px 0 rgba(42, 45, 48, 0.2);
  transition: all 0.3s ease;
  background:#f6f6f6;
  padding:0px;
`;

export const FormContent = styled.div`
  padding: 0 42px;
`;


export const HorizontalLine = styled.hr`
  background-color: black;
  height: 1px;
  border: none; 
  margin: 0 42px 9px 42px;
`;

